export default __webpack_public_path__ + "static/media/reanime-circle-name-image-transparent-dark-compressed.3afddbc3.png";